import { render } from "./NavBarView.vue?vue&type=template&id=aa3c520e&scoped=true"
import script from "./NavBarView.vue?vue&type=script&lang=js"
export * from "./NavBarView.vue?vue&type=script&lang=js"

import "./NavBarView.vue?vue&type=style&index=0&id=aa3c520e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3c520e"]])

export default __exports__